import type { Translations } from '../../i18n';
import type { ModalAction } from './ModalFooter';

/** The handlers of the record actions of an athlete. A page passes a handler
 *  only when the role, the lock and the state of the record allow the action:
 *  no handler, no button. The handler asks its own question (confirm). */
export interface AthleteRecordActionHandlers {
  onArchive?: () => void;
  onRestore?: () => void;
  onRemoveFromTeam?: () => void;
  onUnlink?: () => void;
  onMerge?: () => void;
  /** A write of the page runs: every action is off. */
  disabled?: boolean;
}

/**
 * #675, #693 — the record actions of the Edit Athlete modal: Archive, Restore,
 * Remove from team, Unlink, Merge. The footer shows one action as a text
 * button, and two or more as the items of the Actions menu. AthleteDetail
 * and TeamDetail use it with their own role gates and handlers.
 */
export function athleteRecordActions(t: Translations, h: AthleteRecordActionHandlers): ModalAction[] {
  const out: ModalAction[] = [];
  const add = (a: Omit<ModalAction, 'disabled'>) => out.push({ ...a, disabled: h.disabled });
  if (h.onArchive) add({ label: t.teams.archive, onClick: h.onArchive, destructive: true, testId: 'athlete-archive' });
  if (h.onRestore) add({ label: t.teams.restore, onClick: h.onRestore, testId: 'athlete-restore' });
  if (h.onRemoveFromTeam) add({ label: t.teams.removeFromTeam, onClick: h.onRemoveFromTeam, destructive: true, testId: 'athlete-remove-from-team' });
  if (h.onUnlink) add({ label: t.teams.unlink, title: t.teams.unlinkFromUserAccount, onClick: h.onUnlink, destructive: true, testId: 'athlete-unlink' });
  if (h.onMerge) add({ label: t.athletes.merge.action, onClick: h.onMerge, testId: 'athlete-merge' });
  return out;
}
